import MuteButton from './MuteButton';

export default MuteButton;
